<template>
  <home-page
    :kicker="t.kicker"
    :title="clubName"
    :lead="lead"
    :actions="[t.actions.primary, t.actions.secondary]"
    :stats="stats"
    :setup="setup"
    :tiles-title="t.tilesTitle"
    :tiles="tiles"
    :footnote="t.footnote"
    :loading="loading"
  />
</template>

<script>
import homePages from '@/content/homePages';
import HomePage from '@/views/component/home/HomePage.vue';

export default {
  name: 'vwelcome',

  components: { HomePage },

  data: () => ({
    t: homePages.club,
    loading: true
  }),

  computed: {
    app() {
      return this.$store.state.ClubApp;
    },
    can() {
      return this.$store.getters['ClubAuth/clubCan'];
    },
    clubName() {
      return this.$store.getters['ClubAuth/isClubName'] || this.t.kicker;
    },
    openApprovals() {
      return (this.app.ShootingbookApproval || []).filter(item => item.bestaetigung_status === 1).length;
    },
    todayCount() {
      return (this.app.TodayMember || []).length;
    },
    lead() {
      if (this.loading) return '';
      const approvals = this.openApprovals > 0 ? this.t.lead.approvals(this.openApprovals) : this.t.lead.noApprovals;
      return `${approvals} ${this.t.lead.today(this.todayCount)}`;
    },
    stats() {
      const s = this.t.stats;
      const rangeSafety = (this.app.TodaySA || []).length;
      const stats = [
        {
          id: 'approvals',
          value: this.openApprovals,
          label: s.approvals.label,
          caption: s.approvals.caption,
          to: '/club/authorization',
          highlight: this.openApprovals > 0
        },
        { id: 'today', value: this.todayCount, label: s.today.label, caption: s.today.caption, to: '/club/today' },
        {
          id: 'rangeSafety',
          value: rangeSafety,
          label: s.rangeSafety.label,
          caption: rangeSafety > 0 ? s.rangeSafety.caption : s.rangeSafety.captionNone,
          to: '/club/today'
        }
      ];
      if (this.can.arbeitsstunden) {
        const pending = (this.app.ArbeitsstundenFreigaben || []).length;
        stats.push({
          id: 'workinghours',
          value: pending,
          label: s.workinghours.label,
          caption: s.workinghours.caption,
          to: '/club/arbeitsstunden/freigaben',
          highlight: pending > 0
        });
      }
      return stats;
    },
    setup() {
      // Nur für Vereine, die noch keinen Stand angelegt haben
      if (this.loading || (this.app.ShootingRanges || []).length > 0) return null;
      const done = { verbaende: (this.app.VerbandOwn || []).length > 0 };
      return {
        ...this.t.setup,
        steps: this.t.setup.steps.map(step => ({ ...step, done: done[step.id] || false }))
      };
    },
    tiles() {
      const visible = {
        workinghours: this.can.arbeitsstunden,
        assignments: this.can.arbeitsstunden_full,
        weaponpool: this.can.weapon_pool,
        terminal: this.$store.getters['ClubAuth/can_RFID']
      };
      return this.t.tiles.filter(tile => !(tile.id in visible) || !!visible[tile.id]);
    }
  },

  async created() {
    const load = action => this.$store.dispatch(`ClubApp/${action}`);
    const requests = [
      load('getShootingbookforApproval'),
      load('getTodayMember'),
      load('getTodaySA'),
      load('getRanges'),
      load('getVerband')
    ];
    if (this.can.arbeitsstunden) {
      // Fehler zeigt die Action schon als Popup an
      requests.push(load('getArbeitsstundenFreigaben').catch(() => {}));
    }
    await Promise.all(requests);
    this.loading = false;
  }
};
</script>
